import { render, staticRenderFns } from "./WalletSummary.vue?vue&type=template&id=972609c6&scoped=true&"
import script from "./WalletSummary.vue?vue&type=script&lang=js&"
export * from "./WalletSummary.vue?vue&type=script&lang=js&"
import style0 from "./WalletSummary.vue?vue&type=style&index=0&id=972609c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972609c6",
  null
  
)

export default component.exports